import { cloneDeep, debounce, sum, uniqueId } from "lodash";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Loader";
import axios from "axios";
import { stringify, toggleBodyScroll, velarToast } from "../helper";
import { toast } from "react-toastify";
import { Config } from "../config";
import { SuccessfulModal } from "../modals/SuccessfulModal";
import { FarmDistributorContractService as FarmDistributorContract } from "../services/FarmDistributorContractService";
// import FarmCoreContractService from "../services/FarmCoreContractService";
import { FarmCoreContractService as FarmCoreContract } from '../services/FarmCoreContractService';
import { EpochModal } from "../modals/EpochModal";

const BlockInfo = (props) => {
  const { block, index, settings } = props;
  const [ blockInfo, setBlockInfo ] = useState(block);
  const [state, setState] = useState({ loader: false, successfulModal: false,  details: false, id: uniqueId() })
  const firstEpoch = blockInfo.epochs[0];
  const lastEpoch = blockInfo.epochs.at(-1);
  const epouchs = blockInfo.epochs.length > 1 ? "epochs " + firstEpoch + ".." + lastEpoch : "epoch " + firstEpoch;
  // const FarmCoreContractService = new FarmCoreContract(settings.poolInfo.contracts['farming-core']);
  const FarmDistributorContractService = new FarmDistributorContract(settings.poolInfo.contracts.farm['farming-distributor']);

  const claimRewards = async () => {
    setState({ ...state, loader: true });
    const result = await FarmDistributorContractService.distributeBlocks(blockInfo.epochs, blockInfo);
    setState({ ...state, successfulModal: true });
    velarToast(<div>
      <div className="p-3 pb-0">
        <div className="title">Claiming Rewards from { epouchs }</div>
        <div className="timestamp">Less than 25 sec ago</div>
      </div>
        <a className="link p-4 flex justify-between" target="_blank" href={`${Config.url}txid/${result.txId}?chain=${Config.name}`}>
            View on explorer
            <img className="icon" src="/assets/icons/toast-link-icon.svg" alt="" />
        </a>
    </div>);
  }

  const getRewardData = async () => {
    const reward = await FarmDistributorContractService.getReward(blockInfo.epoch);
    const hasRewards = (Number(reward.value.data.amt.value) > 0 || Number(reward.value.data.amt.value)) > 0;
    // const startBlockNumer = blockInfo.startBlockNumer;
    // const endBlockNumer = blockInfo.end;

    const revShareStaked = Number(reward.value.data.share.data.staked.value);
    const revShareTotal = Number(reward.value.data.share.data.total.value);
    const revAmount = Number(reward.value.data.amt.value);

    let revShare =  ((revShareStaked / revShareTotal) * 100).toFixed(3);
    if (isNaN(revShare)) {
      revShare = 0;
    }
    setState({ ...state, loader: false, details: true });
    setBlockInfo({ ...blockInfo, revShare, hasRewards, revAmount, fetched: true })
  }

  return (
    <div key={index} className="block-info mb-5">
      <div className="block-details" data-accordion="collapse">
        <span style={{ color: '#999', fontSize: 14 }}>Epoch { blockInfo.epoch }</span>
        <button
          onClick={() => {
            if (blockInfo.fetched) {
              setState({ ...state, details: !state.details, loader: false })
            } else {
              getRewardData().then(() => {});
              setState({ ...state, details: !state.details, loader: true })
            }
          }}
          type="button"
          className="block-btn text-pink-100 font-bold text-lg flex items-center justify-between w-full"
          data-accordion-target={"#" + state.id}
          ariaaria-expanded="true"
          aria-controls="collapsible-details"
        >
          <span className="title">{ block.start }</span>
          <div className="dotted-line"></div>
          <span className="title">End Block { blockInfo.end }</span>
          <div>
          <svg
            data-accordion-icon
            className={
              "w-6 h-6 shrink-0 " + (state.details && "rotate-180")
            }
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            ></path>
          </svg>
          </div>
        </button>
        { state.loader ? (
        <div className="p-5">
          <Loader />
        </div>
        ) : (
          <>
          <div id={state.id} className={state.details ? "details" : "details hidden"}>
            <div className="flex items-center justify-between mb-3">
              <div className="key direction-row flex items-center">
                <p className="text text-white">Rewards Share</p>
                <img
                  data-tooltip-id="tooltip"
                  data-tooltip-content={"Rewards Share"}
                  className="icon hand w-[15px] ml-2"
                  src="/assets/icons/icon-help-white.svg"
                  alt=""
                />
              </div>
              <p className="value text-white">{blockInfo.revShare} %</p>
            </div>
            {/* <div className="flex items-center justify-between mb-3">
              <div className="key direction-row flex items-center">
                <p className="text text-white">IDO Tickets</p>
                <img
                  data-tooltip-id="tooltip"
                  data-tooltip-content={"Rewards Share"}
                  className="icon hand w-[15px] ml-2"
                  src="/assets/icons/icon-help-white.svg"
                  alt=""
                />
              </div>
              <p className="value text-white">04</p>
            </div> */}
            { blockInfo.hasRewards ? (
              <button onClick={claimRewards} style={{ color: '#f89d33' }} className="btn btn-rewards">Claim Rewards</button>
            ) : (
              <button className="cursor-default btn btn-rewards">No Rewards found</button>
            ) }
          </div>
          </>
        ) }
      </div>
      { state.successfulModal && (
        <SuccessfulModal
            forType={'rewards'}
            state={state}
            message={`Rewards Claimed from ${epouchs}`}
            onClose={() => {
                setState({ ...state, successfulModal: false });
                toggleBodyScroll(false);
                props.get && props.get();
            }
        } />
      )}
    </div>
  )
}

const selectEpoch = { name: "Select Epoch", epochs: [], hasRewards: false, revAmount: ''  };
export const FarmMyRewards = (props) => {
  const { currentEpoch, settings } = props;
  const dispatch = useDispatch();
  const [ modalClose, setModalClose ] = useState(false);
  const [ state, setState ] = useState({ loader: false, successfulModal: false,  details: false, id: uniqueId() })
  const [ selectedEpoch, setSelectedEpoch ] = useState({ ...selectEpoch });
  const [ loader, setLoader ] = useState(false);
  const [ blocks, setBlocks ] = useState([]);
  const [ epouchState, setEpochState ] = useState({ page: 1, search: '' });
  const auth = useSelector((x) => x.auth);

  const FarmCoreContractService = new FarmCoreContract(settings.poolInfo.contracts.farm['farming-core']);
  const FarmDistributorContractService = new FarmDistributorContract(settings.poolInfo.contracts.farm['farming-distributor']);
  const start_epoch = settings.poolInfo.contracts.farm.start_epoch || 0;

  const firstEpoch = selectedEpoch.epochs[0];
  const lastEpoch = selectedEpoch.epochs.at(-1);
  const epouchs = selectedEpoch.epochs.length > 1 ? "epochs " + firstEpoch + ".." + lastEpoch : "epoch " + firstEpoch;

  const changeEpoch = async (epoch) => {
    setSelectedEpoch(epoch);
    const epochWithreward = await getRewardData(epoch);
    setSelectedEpoch(epochWithreward);
  }

  const claimRewards = async () => {
    setState({ ...state, loader: true });
    try {
      const result = await FarmDistributorContractService.distributeBlocks(selectedEpoch.epochs, selectedEpoch);
      setState({ ...state, successfulModal: true, loader: false });
      velarToast(<div>
        <div className="p-3 pb-0">
          <div className="title">Claiming Rewards from { epouchs }</div>
          <div className="timestamp">Less than 25 sec ago</div>
        </div>
          <a className="link p-4 flex justify-between" target="_blank" href={`${Config.url}txid/${result.txId}?chain=${Config.name}`}>
              View on explorer
              <img className="icon" src="/assets/icons/toast-link-icon.svg" alt="" />
          </a>
      </div>);
    } catch (error) {
      setState({ ...state, successfulModal: false, loader: false });
    }
  }

  const getRewardData = async (blockInfo) => {
      const reward = await FarmDistributorContractService.getReward(blockInfo.epoch);
      const hasRewards = (Number(reward.value.data.amt.value) > 0 || Number(reward.value.data.amt.value)) > 0;

      const revShareStaked = Number(reward.value.data.share.data.staked.value);
      const revShareTotal = Number(reward.value.data.share.data.total.value);
      const claimed = Number(reward.value.data.claimed.value);
      const revAmount = Number(reward.value.data.amt.value);

      let revShare =  ((revShareStaked / revShareTotal) * 100).toFixed(3);
      if (isNaN(revShare)) {
        revShare = 0;
      }
      return { ...blockInfo, revShare, hasRewards, revAmount, claimed: claimed, fetched: true }
  }

  const getEpochsRewards = async (blockInfo) => {
    const rewards = await Promise.all(blockInfo.map((x) => getRewardData(x)));
    rewards.forEach((reward) => {
      reward.loaded = true;
      const blockIndex = blocks.findIndex((x) => x.epoch === reward.epoch);
      if (blockIndex > -1) {
        blocks[blockIndex] = reward;
      }
    })
    setBlocks(cloneDeep(blocks));
  };

  useEffect(() => {
    if (String(props.currentEpoch).trim().length > 0 && Number(props.currentEpoch) > -1) {
      init();
    }
  }, [props.currentEpoch])

  const init = async () => {
    try {
      setLoader(true);
      const epochsRequests = [];
      const start = await FarmCoreContractService.getCalcEpochStart(start_epoch);
      const EpochRange = 199;
      const epochStartRes = [start];
      const epochEndRes = [start + EpochRange];
      const epochs = [];
      let indexer = 0;

      for (let i = start_epoch; i < currentEpoch; i++) {
        if (i === (start_epoch)) {
          epochStartRes.push((epochStartRes[indexer] + EpochRange) + 1);
          epochEndRes.push((epochEndRes[indexer] + EpochRange) + 1);
        } else {
          epochStartRes.push((epochEndRes[indexer] + 1));
          epochEndRes.push((epochEndRes[indexer] + EpochRange) + 1);
        }
        epochs.push(i);
        indexer++;
      }
      const _blocks = [];
      let startEpoch = start_epoch;
      epochs.chunk(1).forEach((reward, index) => {        
        const hasRewards = false; //reward.find((x) => Number(x.value.data.amt.value) > 0 || Number(x.value.data.amt.value) > 0);
        const startBlockNumer = epochStartRes[index];
        const endBlockNumer = epochEndRes[index];
        const revShareStaked = 0; //reward.map((x) => Number(x.value.data.share.data.staked.value));
        const revShareTotal = 0; //reward.map((x) => Number(x.value.data.share.data.total.value));
        let revShare =  ((sum(revShareStaked) / sum(revShareTotal)) * 100).toFixed(3);
        if (isNaN(revShare)) {
          revShare = 0;
        }

        _blocks.push(
          { revShare, epoch: startEpoch, epochs: [startEpoch], startBlockNumer: startBlockNumer, start: `Start Block ${startBlockNumer}`, end: endBlockNumer, hasRewards }
        )
        startEpoch += 1;
      })
      setBlocks([ ..._blocks ])
      setLoader(false);      
    } catch (error) {
      console.log(error);
      setLoader(false);      
    }
  }

  return (
    <div className="my-rewards">
      { loader ? (
        <div className="p-5 m-5">
          <Loader />
        </div>
      ) : (
        <div className="block-list px-3 py-1">
          <div class="text-center mb-5 mt-5">
            <h3 class="color-velar">Your rewards</h3>
            <h2 class="text-white" style={{ fontSize: 32 }}>{ selectedEpoch.revAmount || '0.00' }</h2>
          </div>

          <div onClick={() => { setModalClose(!modalClose); }} className="epoch-dropdown direction-col p-2 ampl-padding flex items-center justify-between">
              <div className="direction-row justify-between flex">
                <div className="lg-text">
                  { selectedEpoch.name }
                </div>
                <div style={{ transform: 'rotate(0deg)' }} className="flex hand items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M12.0605 13.2323L17.3534 7.93945L18.7676 9.35367L12.0605 16.0608L5.35336 9.35367L6.76758 7.93945L12.0605 13.2323Z" fill="#F5F7FA" fillOpacity="0.6" />
                    </svg>
                </div>
              </div>
          </div>

          { !selectedEpoch.revAmount && (
            <div className='no-lp-token'>
              Start staking to earn rewards!
            </div>
          ) }

          { state.loader ? (
            <button className="btn btn-insufficient mt-4 mb-3">
              <Loader />
            </button>
          ) : (selectedEpoch.claimed > 0) ?
            <button className="btn btn-insufficient mt-4 mb-3">
               <div className="flex justify-center items-center gap-2">                                            
                    <span className="color-velar">
                        Claimed
                    </span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.81335 5.85967L6.95335 8.72634L5.85335 7.62634C5.79358 7.55655 5.72004 7.49987 5.63733 7.45986C5.55462 7.41984 5.46453 7.39736 5.37272 7.39381C5.2809 7.39026 5.18935 7.40573 5.1038 7.43925C5.01825 7.47277 4.94055 7.5236 4.87558 7.58857C4.81061 7.65354 4.75977 7.73124 4.72625 7.81679C4.69274 7.90234 4.67727 7.9939 4.68081 8.08571C4.68436 8.17752 4.70685 8.26761 4.74686 8.35032C4.78688 8.43303 4.84356 8.50658 4.91335 8.56634L6.48001 10.1397C6.54231 10.2015 6.61618 10.2503 6.69741 10.2835C6.77863 10.3167 6.86561 10.3335 6.95335 10.333C7.12824 10.3323 7.29584 10.2628 7.42001 10.1397L10.7533 6.80634C10.8158 6.74437 10.8654 6.67063 10.8993 6.58939C10.9331 6.50815 10.9505 6.42102 10.9505 6.33301C10.9505 6.245 10.9331 6.15786 10.8993 6.07662C10.8654 5.99538 10.8158 5.92165 10.7533 5.85967C10.6284 5.73551 10.4595 5.66581 10.2833 5.66581C10.1072 5.66581 9.93826 5.73551 9.81335 5.85967ZM8.00001 1.33301C6.68147 1.33301 5.39254 1.724 4.29621 2.45654C3.19988 3.18909 2.3454 4.23028 1.84082 5.44845C1.33623 6.66663 1.20421 8.00707 1.46144 9.30028C1.71868 10.5935 2.35362 11.7814 3.28597 12.7137C4.21832 13.6461 5.4062 14.281 6.69941 14.5382C7.99262 14.7955 9.33306 14.6635 10.5512 14.1589C11.7694 13.6543 12.8106 12.7998 13.5431 11.7035C14.2757 10.6071 14.6667 9.31822 14.6667 7.99967C14.6667 7.1242 14.4942 6.25729 14.1592 5.44845C13.8242 4.63961 13.3331 3.90469 12.7141 3.28563C12.095 2.66657 11.3601 2.17551 10.5512 1.84048C9.7424 1.50545 8.87549 1.33301 8.00001 1.33301ZM8.00001 13.333C6.94518 13.333 5.91403 13.0202 5.03697 12.4342C4.15991 11.8481 3.47632 11.0152 3.07266 10.0407C2.66899 9.06611 2.56337 7.99376 2.76916 6.95919C2.97495 5.92463 3.4829 4.97432 4.22878 4.22844C4.97466 3.48256 5.92497 2.97461 6.95953 2.76882C7.9941 2.56303 9.06645 2.66865 10.041 3.07232C11.0155 3.47598 11.8485 4.15957 12.4345 5.03663C13.0206 5.91369 13.3333 6.94484 13.3333 7.99967C13.3333 9.41416 12.7714 10.7707 11.7712 11.7709C10.7711 12.7711 9.4145 13.333 8.00001 13.333Z" fill="#F5F7FA" fill-opacity="0.36"/>
                    </svg>                                    
                </div>
            </button>
          : selectedEpoch.hasRewards ? (
            <button onClick={claimRewards} className="btn btn-orange btn-warning mt-4 mb-3">Claim rewards</button>
          ) : (
            <button className="btn btn-insufficient mt-4 mb-3">No rewards to claim</button>
          ) }
          {modalClose && (
            <EpochModal 
              blocks={blocks} 
              get={init}
              epouchState={epouchState}
              getRewards={getEpochsRewards}
              setEpochState={setEpochState}
              onSelect={(blockInfo) => {
                changeEpoch(blockInfo);
                setModalClose(!modalClose);
              }}
              settings={settings}
              onClose={() => { setModalClose(!modalClose); }} />
          )}
          {/* {blocks.map((block, index) => {
            return <BlockInfo settings={settings}  key={index} {...props} block={block} index={index} />
          })} */}
        </div>
      )}
      {/* <button className="btn btn-warning">Claim all rewards</button> */}

      { state.successfulModal && (
        <SuccessfulModal
            forType={'rewards'}
            state={state}
            message={`Rewards Claimed from ${epouchs}`}
            onClose={() => {
                setSelectedEpoch({ ...selectEpoch  })
                setState({ ...state, successfulModal: false });
                toggleBodyScroll(false);
                props.get && props.get();
            }
        } />
      )}
    </div>
  );
};

